// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Product } from './product';
import { ProductUnitOfMeasure } from './product-unit-of-measure';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductCategoryInventoryAdjustment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  adjustmentDate!: Date;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  notes?: string;
  price!: number;
  productId!: number;
  quantity!: number;
  unitOfMeasureId!: number;
  vendorId?: number;
  product!: Product;
  unitOfMeasure!: ProductUnitOfMeasure;
  vendor!: Vendor;
}

